import React, { Component } from 'react';
import { connect } from 'react-redux';
import {InputText} from 'primereact/inputtext';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Link} from 'react-router-dom';
import {Button} from 'primereact/button';
import { HASACCESS } from '../../../shared/utility';
import { DATATABLE_CONFIG, PROJECT_SUBMENU_ID } from '../../../shared/Config';
import {Toast} from 'primereact/toast';
import Messages from '../../../shared/UI/Messages/Messages';
import * as actions from '../../../store/actions/index';

class ProjectList extends Component {
    state = {
        selectedItems: []
    }


    
    delete= () => {

        if(this.state.selectedItems.length > 0){
            const updatedValue = this.state.selectedItems.map( value => {
                return { DeleteID : value.projectid};
            })
            this.props.dynamicDeleteProcess('Project',updatedValue,'Employee/GetProjectList');
        }
        else{
            this.growl.show({severity: 'error', summary: null, detail: 'Please select checkbox'});
        }

    }


    componentDidMount(){   
         this.getAccess = HASACCESS(PROJECT_SUBMENU_ID);     
        this.props.getMasterTableList('Employee/GetProjectList');    
    }

   

    actionTemplate = (rowData, column) => {
        //let rowIndex = column.rowIndex;
        return <div className="actionCenter">
            {(this.getAccess!==undefined && this.getAccess.editAccess!== false) &&
        <Link to={"/Project/edit/"+rowData.projectid}><Button type="button" icon="pi pi-pencil" className="p-button-info" ></Button></Link>
            }
            {(this.getAccess!==undefined && this.getAccess.viewAccess!== false) &&
        <Link to={"/Project/view/"+rowData.projectid}><Button type="button" icon="pi pi-eye" className="p-button-secondary" ></Button></Link>
            }
        </div>;
    }


 

  
    render() {   

        if(this.getAccess!==undefined && this.getAccess.viewAccess === false){
            this.props.history.push('/dashboard');
        }

        let tableData = []    
        if(this.props.tableLists && this.props.tableLists.length > 0){
            tableData = this.props.tableLists;
        }

        

        const header = (
            <div style={{'textAlign':'right'}}>
                <InputText type="search" onInput={(e) => this.setState({globalFilter: e.target.value})} placeholder="Search..." />
            </div>
        );

        return (
            <div className="p-grid padding">
                { this.props.loading && <div className="page-loader"></div>}
                { this.props.error !== null && <Messages type="error" message={this.props.error}/>}
                { this.props.success !== null && <Messages type="success" message={this.props.success}/>}
                <Toast ref={(el) => this.growl = el} />
                <div className="p-col-12">
                    <div className="card card-w-title" style={{position:'relative'}}>
                        <h1>Project Details</h1>
               
                        <div className="p-grid">
                            

                            <div className="p-col-12 p-md-12">
                                <div className="mt1">
                                {(this.getAccess!==undefined && this.getAccess.addAccess!== false) &&
                                    <Link to="/Project/add/new"><Button style={{float: 'right'}} label="Add Project" icon="pi pi-plus" className="ml1" /></Link>
                                }

                                {(this.getAccess!==undefined && this.getAccess.deleteAccess!== false) &&
                                    <Button onClick={this.delete} style={{float: 'right'}} label="Delete" icon="pi pi-trash"  className="p-button-danger"/>
                                }
                                </div>                                
                            </div>
                      
                            					 	
                        <div className="p-col-12" style={{marginTop:'2em'}}>


                     
                        <DataTable value={tableData} 
                         selection={this.state.selectedItems} onSelectionChange={e => this.setState({selectedItems: e.value})}
                         globalFilter={this.state.globalFilter} header={header}  dataKey="projectid"   {...DATATABLE_CONFIG}>
                                <Column selectionMode="multiple" style={{width:'3em'}}/>
                                <Column field="projectid"  style={{display:'none'}}/>
                                <Column field="projectnumber" header="Code" sortable={true} />
                                <Column field="projectdesc" header="Project Name"  />
                                <Column field="startdate" header="Project Start"/>
                                <Column field="enddate" header="Project End" />
                                <Column body={this.actionTemplate} header="Action"/>
                            </DataTable>
                        </div>
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return{
        loggedUserDetail : state.auth.userObject,
        loading : state.master.loading,
        error : state.master.error,
        success: state.master.success,
        tableLists : state.master.tableLists
    }
}
  
const mapDispatchToProps = dispatch => {
    return{
        dynamicDeleteProcess: (model,data,func) => dispatch(actions.dynamicDeleteProcess(model,data,func)),
        getMasterTableList: (table) => dispatch(actions.getMasterTableList(table)),
    }
}

  
export default connect(mapStateToProps,mapDispatchToProps)(ProjectList);